import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { PredictionService } from '../../prediction.service';
import { PredictionResult } from '../../prediction-result';
import { UploadProgressService } from '../../upload-progress.service';

@Component({
  selector: 'app-predictor-section',
  templateUrl: './predictor-section.component.html',
  styleUrls: ['./predictor-section.component.css']
})
export class PredictorSectionComponent implements OnInit {
  form: FormGroup;

  result: PredictionResult = null;
  apiPing: boolean = null;
  fileMissing: boolean = null;

  constructor(
    private formBuilder: FormBuilder,
    private predictionService: PredictionService,
    public uploadProgressService: UploadProgressService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      binary: ['', Validators.required]
    });
    this.predictionService.pingApi().subscribe(
      res => this.apiPing = res
    );
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.get('binary').setValue(file);
      this.fileMissing = false;
    }
  }

  onSubmit() {
    if (this.form.valid) {
      const formData = new FormData();
      formData.append('exec', this.form.get('binary').value);

      this.predictionService.sendFile(formData).subscribe(
        res => this.result = res
      );
    } else {
      this.fileMissing = true;
    }
  }
}
